import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import { useState } from "react";
import { Checkbox, MenuItem, Select } from "@mui/material";
import { getSelectingCustomerShopList } from "../utils/customerSendGroup";



function CurrentSelectingShopListPart ({selectingCustomerShopList}) {
  return (
    <Box>
      <Typography>選択中の店舗</Typography>
      <Box border="1px black solid" padding={1} minHeight="40vh">
        {
          selectingCustomerShopList.map((customerData) => {
            if (customerData.selected_shop_list.length > 0) {
              return (
                <>
                  <Typography fontWeight="bold">{customerData.customer_name}</Typography>
                  {
                    customerData.selected_shop_list.map((shopData) => (
                      <Typography ml={2}>{shopData.shop_name}</Typography>
                    ))
                  }
                </>
              );
            }
            
            return null;
          })
        }
      </Box>
    </Box>
  )
}

function ShopSelectionPart ({customerShopList, setCustomerShopList}) {

	const [selectingCustomerIndexValue, setSelectingCustomerIndexValue] = useState("-1");

	const getShopsAllSelected = (customerIndex) => {
		if (customerIndex < 0) {
			return false;
		}    

		return customerShopList[customerIndex].shop_list.every((data) => data.is_selected);
	}

	const handleChangeSelectingCustomer = (event) => {
		setSelectingCustomerIndexValue(event.target.value);
	}

	const handleChangeShopChecked = (customerIndex, shopindex) => (event) => {
		let newCustomerList = [...customerShopList];
		newCustomerList[customerIndex].shop_list[shopindex].is_selected = event.target.checked;
		setCustomerShopList(newCustomerList);
	}

	const handleClickShopAllChanged = (customerIndex, checked) => (event) => {
		let newCustomerList = [...customerShopList];
		newCustomerList[customerIndex].shop_list.forEach((shopData) => {
			shopData.is_selected = checked;
		});
		setCustomerShopList(newCustomerList);
	}

	const selectingCustomerIndex = parseInt(selectingCustomerIndexValue);

	return (
		<Box>
			<Typography>店舗一覧</Typography>
			<Box border="1px black solid" padding={1} minHeight="40vh">      
				<Grid container spacing={2} alignItems="center">
					<Grid item xs="auto">
						<Select
							value={selectingCustomerIndexValue}
							onChange={handleChangeSelectingCustomer}
							sx={{minWidth: 200}}
						>
							<MenuItem key="customer_unselected" value="-1">[未選択]</MenuItem>
							{
								customerShopList.map((customerData, i) => {
									if (customerData.shop_list.length > 0) {
										return (
											<MenuItem key={`customer_${i}`} value={i.toString()}>
												{customerData.customer_name}
											</MenuItem>
										);
									}

									return null;
								})                
							}   
						</Select>
					</Grid>
					<Grid item xs>
						<Button
							variant="contained"
							onClick={handleClickShopAllChanged(selectingCustomerIndex, !getShopsAllSelected(selectingCustomerIndex))}
							disabled={selectingCustomerIndex < 0}
						>
							{getShopsAllSelected(selectingCustomerIndex) ? "全解除" : "全選択"}
						</Button>
					</Grid>
				</Grid>
				{
					selectingCustomerIndex < 0
						? null
						: customerShopList[parseInt(selectingCustomerIndex)].shop_list.map((shopData, shopIndex) => (
								<Grid key={`shop_${shopIndex}`} container alignItems="center">
									<Grid item xs="auto">
										<Checkbox
											checked={shopData.is_selected}
											onChange={handleChangeShopChecked(selectingCustomerIndex, shopIndex)}
										/>
									</Grid>
									<Grid item xs>
										<Typography>{shopData.shop_name}</Typography>
									</Grid>
								</Grid>
						))
				}
			</Box>
		</Box>
	)
}

// 取引先送信グループ店舗選択
export default function CustomerSendGroupShopSelectPart ({customerShopList, setCustomerShopList}) {

	return (
		<Grid container spacing={2}>
			<Grid item xs>
				<CurrentSelectingShopListPart selectingCustomerShopList={getSelectingCustomerShopList(customerShopList)} />
			</Grid>
			<Grid item xs>
				<ShopSelectionPart customerShopList={customerShopList} setCustomerShopList={setCustomerShopList} />
			</Grid>
		</Grid>
	)
}
